"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "alta-val-tidone": {
    "59b85a88": [{
      "hkey": "5306e158",
      "slug": "alta-val-tidone",
      "name": "Alta Val Tidone",
      "primary": true,
      "skipSearch": false
    }],
    "costiola": [{
      "hkey": "5306e158",
      "slug": "alta-val-tidone",
      "name": "Alta Val Tidone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d53f4d57": [{
      "hkey": "0aab9f24",
      "slug": "sala-mandelli",
      "name": "Sala Mandelli",
      "primary": true,
      "skipSearch": false
    }],
    "mandelli": [{
      "hkey": "0aab9f24",
      "slug": "sala-mandelli",
      "name": "Sala Mandelli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "alta-val-tidone"
    }],
    "4aad6116": [{
      "hkey": "0aab9f24",
      "slug": "sala-mandelli",
      "name": "Sala Mandelli",
      "primary": true,
      "skipSearch": false
    }],
    "sala": [{
      "hkey": "0aab9f24",
      "slug": "sala-mandelli",
      "name": "Sala Mandelli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;